import React, { useMemo, useState, useContext } from 'react'
import { Box } from '@mui/joy';
import { useTranslation } from 'react-i18next';
import { KPI } from 'src/mtska-frontend-app-component';
import { useSettingsContext } from 'src/mtska-frontend-app-scaffolding';

const dataProviderName = 'cars/car';

const mergeKpiFilters = (baseFilters, extraItems = []) => ({
    items: [...(baseFilters?.items ?? []), ...extraItems],
});

const RentalManagerCarKPI = ({ filters, setFilters, userCapabilities, deferLoad = false }) => {
    const { t } = useTranslation();
    const { addFilter } = useSettingsContext(dataProviderName);

    return useMemo(() => <>
        <Box className="mtska-chart-wrapper">
            <KPI
                deferLoad={deferLoad}
                title="running"
                icon="faCar"
                dataProviderName={'statisticsviews/running/count/cars/car'}
                filterbutton={{
                    visible: true,
                    label: t("View"),
                    callback: () => { addFilter("status", "running", "equals") }
                }}
                filters={mergeKpiFilters(filters, [{
                    field: "status",
                    operator: "equals",
                    value: "running"
                }])}
            />
            <KPI
                deferLoad={deferLoad}
                title="in_order"
                icon="faCartShopping"
                dataProviderName={'statisticsviews/order/count/cars/car'}
                filterbutton={{
                    visible: true,
                    label: t("View"),
                    callback: () => { addFilter("status", "in_order", "equals") }
                }}
                filters={mergeKpiFilters(filters, [{
                    field: "status",
                    operator: "equals",
                    value: "in_order"
                }])}
            />
            <KPI
                deferLoad={deferLoad}
                title="closed"
                icon="faFolder"
                dataProviderName={'statisticsviews/closed/count/cars/car'}
                filterbutton={{
                    visible: true,
                    label: t("View"),
                    callback: () => { addFilter("status", "closed", "equals") }
                }}
                filters={mergeKpiFilters(filters, [{
                    field: "status",
                    operator: "equals",
                    value: "closed"
                }])}
            />
            <KPI
                deferLoad={deferLoad}
                title="canceled"
                icon="faTrash"
                dataProviderName={'statisticsviews/closed/count/cars/car'}
                filterbutton={{
                    visible: true,
                    label: t("View"),
                    callback: () => { addFilter("status", "canceled", "equals") }
                }}
                filters={mergeKpiFilters(filters, [{
                    field: "status",
                    operator: "equals",
                    value: "canceled"
                }])}
            />
            <KPI
                deferLoad={deferLoad}
                title="Total"
                icon="faCars"
                dataProviderName={'statisticsviews/item/count/cars/car'}
                filters={filters}
            />
        </Box>
    </>, [filters, deferLoad, t, addFilter])

}

export default RentalManagerCarKPI;


